const switchContext = ({ context }) => {
  let paramType: string;
  let entityType: string;

  switch (context) {
    case "course":
      entityType = "course";
      paramType = "course_id";
      break;

    case "plan":
      entityType = "plan";
      paramType = "plan_id";
      break;

    case "media_space_content":
      entityType = "media-space-content";
      paramType = "media_space_content_id";
      break;

    case "product_bundle":
      entityType = "product-bundle";
      paramType = "product_bundle_id";
      break;

    default:
      break;
  }

  return { entityType, paramType };
};

export default switchContext;
